/**
 * Currency: 1 234,567 DT (3 décimales tunisiennes — millimes)
 */
export function formatTND(amount: number): string {
  if (!isFinite(amount)) return '0,000 DT';
  const fixed = amount.toFixed(3).replace('.', ',');
  const [intPart, decPart] = fixed.split(',');
  const grouped = (intPart ?? '0').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${grouped},${decPart} DT`;
}

/**
 * Date: DD/MM/YYYY
 */
export function formatDate(value: string | Date): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${d.getFullYear()}`;
}

export function formatDateTime(value: string | Date): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  if (isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${d.getFullYear()} ${hh}:${mm}`;
}
